<template>
  <div class="white">
    <devicesummary
      :key="key"
      :deviceMakeModels="deviceMakeModels"
      :loadingkey="loadingKey"
      :device="deviceInfo"
      :serviceAccounts="deviceServiceAccounts"
      :availablegraphs="availableGraphs"
      :apiurl="apiUrl"
      :apitoken="apiToken"
      :deviceports="devicePorts"
      :hsiprofiles="hsiProfiles"
      :wifiprofiles="wifiProfiles"
      :voipprofiles="voipProfiles"
      :speedprofiles="speedProfiles"
      :endlocations="endLocations"
      :networks="locationNetworks"
      :nodes="locationNodes"
      :switchingcentres="switchingCentres"
      :devicelevel="deviceLevel"
      :upstreamdevices="upstreamDevices"
      :zhonebridges="zhoneBridges"
      :acsprofiles="acsProfiles"
      :bridgetemplates="bridgeTemplates"
      :zhonetrafficprofiles="zhoneTrafficProfiles"
      :devicetickets="deviceTickets"
      :devicecomments="deviceComments"
      :onustatus="onuStatus"
      :oltstatus="oltstatus"
      :providers="providers"
      :organisationbridgetemplates="organisationBridgeTemplates"
      :linkeddevices="linkedDevices"
      :acsInfo="configurationSettings"
      @checkZhoneBridges="getZhoneBridges()"
      @refreshAcsBridges="getAcsProfiles()"
      @refreshWifiConnections="getWifiProfiles(), fetchDeviceTickets()"
      @refreshTickets="fetchDeviceTickets()"
    ></devicesummary>
  </div>
</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import axios from "axios";
import flat from 'flat'
import deviceSummary from "@/components/DeviceSummary";
const CancelToken = axios.CancelToken;
let source = null


export default {
  components: {
    devicesummary: deviceSummary
  },
  data() {
    return {
      showDetails: true,
      loading: false,
      expand: false,
      search: "",
      configurationSettings: null,
      dialog: false,
      deviceLevel: "",
      pagination: {},
      deviceInfo: {},
      headers: [],
      availableGraphs: [],
      deviceMakeModels: [],
      apiUrl: "",
      apiToken: "",
      key: 0,
      loadingKey: 0,
      organisationBridgeTemplates: [],
      devices: [],
      linkedDevices: [],
      devicePorts: [],
      hsiProfiles: [],
      wifiProfiles: [],
      voipProfiles: [],
      speedProfiles: [],
      endLocations: [],
      locationNetworks: [],
      locationNodes: [],
      upstreamDevices: [],
      switchingCentres: [],
      zhoneBridges: [],
      bridgeTemplates: [],
      zhoneTrafficProfiles: [],
      deviceComments: [],
      deviceTickets: [],
      acsProfiles: [],
      providers: [],
      onuStatus: {
        initiated: false,
        isOnline: false,
        opticRssi: 0,
        rxPower: 0
      },
      oltstatus: {
        initiated: false,
        isOnline: false,
        cpu: 0,
        temperature: 0,
        memory: 0
      },
      setIntervalId: null
    };
  },

watch: {
  '$route.params.deviceId': {
    immediate: true,
    handler(val){
      if(val){
      this.initialize()

      }
    }
  }
},
  computed: {
    formattedDate() {
      return this.due ? format(this.due, "Do MMM YYYY") : "";
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  async created() {
    source = CancelToken.source();
    // let route = await this.$store.state.currentOrg.org.permissions.filter(
    //   function(el) {
    //     return el.url === "/devices/:deviceId";
    //   }
    // );
    // if (route.length > 0) {
    //   await this.$store.dispatch("setCurrentRoute", route[0]);
    //   if (this.authRead(this.$store.state.currentRoute) === true) {
    //     this.initialize();
    //   }
    // } else {
    //   this.$router.push({ name: "SplashPage" });
    // }
  },
  async destroyed() {
    await this.clearIntervalListener(this.setIntervalId);
    source.cancel("Operation canceled by the user.");
  },

  methods: {
    getOrganisations() {
      Api()
        .get("/customer/organisation/basic/providers")
        .then(response => {
          this.providers = response.data;
          this.providers.push({
            id: this.$store.state.currentOrg.org.id,
            name: this.$store.state.currentOrg.org.name
          });
          this.providers.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0
          );
        });
    },
    clearIntervalListener(id) {
      clearInterval(id);
    },
    async getDeviceMakeModels() {
      await Api()
        .get("/deviceMakeModels")
        .then(response => {
          this.deviceMakeModels = response.data;
        });
    },
    async fetchEndLocations() {
      await Api()
        .get("/locations")
        .then(response => {
          this.endLocations = response.data;
        });
    },
    async fetchLocationNetworks() {
      await Api()
        .get("/locationNetworks")
        .then(response => {
          this.locationNetworks = response.data;
        });
    },
    fetchLocationNodes() {
      Api()
        .get("/locationNodes")
        .then(response => {
          this.locationNodes = response.data;
          this.loadingKey += 1
        });
    },
    fetchSwitchingCentres() {
      Api()
        .get("/switchingCentres")
        .then(response => {
          this.switchingCentres = response.data;
          this.loadingKey += 1
        });
    },
    fetchSpeedProfiles() {
      Api()
        .get("/speedProfiles")
        .then(response => {
          this.speedProfiles = response.data;
          this.loadingKey += 1
        });
    },
    fetchServiceAccounts() {
      Api()
        .get("/serviceAccounts/byDevice/"+this.$route.params.deviceId)
        .then(response => {
          this.deviceServiceAccounts = response.data;
          this.loadingKey += 1
        });
    },
    
    fetchDevices() {
      // this.isLoading = true;
      // Api()
      //   .get("/devices/active")
      //   .then(response => {
      //     this.devices = response.data;
      //     this.loadingKey += 1
      //     // this.isLoading=false
      //     // this.headers=[]
      //     // let headers=Object.keys(this.devices[0]);
      //     // for (let i=0; i< headers.length;i++){
      //     //   this.headers.push({text: headers[i],
      //     // align: "center", sortable: false})
      //     // }

      //     this.key += 1;
      //   });
    },
    fetchUpstreamDevice(deviceTypeId) {
      Api()
        .get("/devices/showUpstreamDevices/" + deviceTypeId)
        .then(response => {
          this.upstreamDevices = response.data.filter(function(el) {
            return el.deviceMakeModel !== null;
          });
          this.loadingKey += 1
        });
    },
    getACSDeviceStatus(ponMac) {
      this.onuStatus.initiated = true
      Api()
        .get("/acs/deviceDetail/" + ponMac)
        .then(response => {
          this.onuStatus = {
            initiated: true,
            isOnline: response.data.message.uptime > 0 ? true : false,
            lastUpdated: new Date(response.data.message.last_msg),
            uptime: response.data.message.uptime,
            complete: true
          };
        });
    },
    getU2000OnuStatus(obj){
       this.onuStatus.initiated = true
       Api().get('/u2000/ontStatus', {
         params: {
           deviceName: obj.upstreamDevice.systemName,
           frameId: obj.frame,
           slotId: obj.slot,
           portId: obj.port,
           onuId: obj.ponId
         }
       }).then(res=>{
         this.onuStatus.isOnline = res.data.data.RUNSTAT == 'Up'?true:false
         this.onuStatus.uptime = new Date(res.data.data.LSTUPTIME)
         this.onuStatus.lastDowntime = new Date(res.data.data.LSTDOWNTIME)
         this.onuStatus.lastDownCause = res.data.data.LSTDOWNCAUSE

         console.log(this.onuStatus)
       })
    },

    getU2000OnuDetails(obj){
       this.onuStatus.initiated = true
       Api().get('/u2000/ontDDM', {
         params: {
           deviceName: obj.upstreamDevice.systemName,
           frameId: obj.frame,
           slotId: obj.slot,
           portId: obj.port,
           onuId: obj.ponId
         }
       }).then(res=>{
         this.deviceInfo.details = res.data.data
         this.key+=1
       })
    },

    getOnuStatus(handleId) {
      this.onuStatus.initiated = true
      if(this.onuStatus.complete){
        this.onuStatus.complete = false
        Api().get('/zhone/onuStatus/'+handleId,{
        cancelToken: source.token
      })
      .then(response=>{
        if(response.data.code == 200){
           this.onuStatus={
            initiated: true,
            isOnline: ((response.data.data.onuStatusWord == '00000000000000000000001')||response.data.data.onuStatusWord == '01000000000000000000001')? true : false,
            opticRssi: parseFloat(response.data.data.opticRssi)/10,
            rxPower: parseFloat(response.data.data.rxPower)/10,
            lastUpdated: new Date(),
            complete: true
          }
        } else {
           this.onuStatus={
            initiated: true,
            isOnline: false,
            opticRssi: parseFloat(response.data.data.opticRssi)/10,
            rxPower: parseFloat(response.data.data.rxPower)/10,
            lastUpdated: new Date(),
            complete: true
          }
        }
         
          
      })
      }
      
    },
    getOltStatus(deviceName){
      this.oltstatus.initiated = true
      Api().get('/u2000/deviceInfo/'+deviceName).then((response, err)=>{
        if(err){
          this.oltstatus.isOnline = false
        } else {
          this.oltstatus.isOnline = true
          this.oltstatus.temperature = response.data.data.TEMPERATURE
          this.oltstatus.memory = response.data.data.MEM
          this.oltstatus.cpu = response.data.data.CPU
          console.log(this.oltstatus)
        }
      })

    },
    async getDeviceInfo() {
      await Api()
        .get("/devices/" + this.$route.params.deviceId)
        .then(async response => {
          let deviceInfo = response.data;
          this.headers = [];
          let headers = Object.keys(deviceInfo);
          console.log(deviceInfo)
          for (let i = 0; i < headers.length; i++) {
            this.headers.push({ text: headers[i], align: "center" });
          }
          

          if (deviceInfo.locationId !== null) {
            this.deviceLevel = "End Location";
          } else if (deviceInfo.locationNetworkId !== null) {
            this.deviceLevel = "Network";
          } else if (deviceInfo.locationNodeId !== null) {
            this.deviceLevel = "Node";
          } else if (deviceInfo.switchingCentreId !== null) {
            this.deviceLevel = "Switching Centre";
          }
          
            this.deviceInfo = deviceInfo;
            if (deviceInfo.Handle_ID !== null&&deviceInfo.Handle_ID>0) {
            // this.getOnuStatus(deviceInfo.Handle_ID);
            this.onuStatus.complete = true
            this.setIntervalId = setInterval(() => {
              console.log(deviceInfo.Handle_ID)
              this.getOnuStatus(deviceInfo.Handle_ID);
            }, 5000);
          } else if (deviceInfo.isU2000&&deviceInfo.deviceMakeModel&&deviceInfo.deviceMakeModel.deviceTypeId == 1) {
            // this.setIntervalId = setInterval(()=>{
              this.getU2000OnuStatus(deviceInfo)
              this.getU2000OnuDetails(deviceInfo)
            // }, 5000)
          } else if(deviceInfo.isU2000){
            this.getOltStatus(deviceInfo.systemName)
          }
          
          if (this.deviceInfo.deviceMakeModel.isWifi) {
            this.getWifiProfiles();
          }
          if (this.deviceInfo.deviceMakeModel.isVoip) {
            this.getVoipProfiles();
          }
        });
    },
    async getZhoneBridges() {
      await Api()
        .get("/deviceBridge/" + this.$route.params.deviceId)
        .then(response => {
          this.zhoneBridges = response.data;
          this.loadingKey += 1
        });
    },
    async getAcsProfiles() {
      await Api()
        .get("/deviceBridge/" + this.$route.params.deviceId)
        .then(response => {
          this.acsProfiles = response.data;
          this.loadingKey += 1
        });
    },
    async getHsiProfiles() {
      await Api()
        .get("/deviceHsi/byDevice/" + this.$route.params.deviceId)
        .then(async response => {
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].viewMore = await false;
          }
          this.hsiProfiles = response.data;
        });
    },
    async getWifiProfiles() {
      await Api()
        .get("/deviceWifi/byDevice/" + this.$route.params.deviceId)
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].viewMore = false;
          }
          this.wifiProfiles = response.data;
          this.loadingKey += 1
        });
    },
    async getVoipProfiles() {
      await Api()
        .get("/deviceVoip/byDevice/" + this.$route.params.deviceId)
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].viewMore = false;
          }
          this.voipProfiles = response.data;
          this.loadingKey += 1
        });
    },
    async getBridgeTemplates() {
      await Api()
        .get("/bridgeTemplate")
        .then(response => {
          this.bridgeTemplates = response.data;
        });
    },

    async getZhoneTrafficProfiles() {
      await Api()
        .get("/zhoneTrafficProfile")
        .then(response => {
          this.zhoneTrafficProfiles = response.data;
          console.log(this.zhoneTrafficProfiles)
        });
    },
    async getOrganisationBridgeTemplates(){
      await Api().get('/organisationBridgeTemplate').then(res=>{
        this.organisationBridgeTemplates = res.data.filter(x=>x.deviceMakeId === this.deviceInfo.deviceMakeModel.deviceMakeId)
      })
    },
    async getLinkedDevices(){
      await Api().get('/devices/searchByUpstreamDevice/'+this.deviceInfo.id).then(res=>{
        this.linkedDevices = res.data
      })
    },

    async initialize() {
      await this.getDeviceInfo();
      if (this.deviceInfo.deviceMakeModel.deviceTypeId == 1&&this.deviceInfo.deviceMakeModel.deviceMake.name.includes("Zhone")) {
        this.getZhoneBridges();
        this.getZhoneTrafficProfiles();
      // } else if (this.deviceInfo.deviceMakeModel.deviceTypeId == 1&&this.deviceInfo.acsDevice) {
      //   this.getAcsProfiles();
      } else if(this.deviceInfo.deviceMakeModel.deviceTypeId == 1&&this.deviceInfo.isU2000){
        this.getAcsProfiles();
      }
      this.fetchServiceAccounts()
      this.getLinkedDevices()

      if(this.deviceInfo.acsDevice&&this.deviceInfo.acsId){
        this.getACSInfo(this.deviceInfo.acsId)
      }
      this.getOrganisations();
      this.getDeviceMakeModels();
      this.getOrganisationBridgeTemplates()
      this.getBridgeTemplates();
      this.fetchSpeedProfiles();
      this.fetchEndLocations();
      this.fetchLocationNetworks();
      this.fetchLocationNodes();
      this.fetchSwitchingCentres();
      this.fetchDeviceTickets();
      this.fetchDeviceComments();
      if (
        this.deviceInfo.deviceMakeModel.deviceType.upstreamDeviceTypeId !== null
      ) {
        this.fetchUpstreamDevice(
          this.deviceInfo.deviceMakeModel.deviceType.upstreamDeviceTypeId
        );
      }

      // await this.fetchDevices()
    },
    
    getACSInfo(acsId){
      Api().get('/acs/glue/device/' + acsId, {
        params: {
          projection: 'InternetGatewayDevice.DeviceInfo.DeviceLog'
        }
      }).then(res=>{
        let data = flat(res.data[0])
        this.configurationSettings = data
        
        console.log(this.configurationSettings)
      })
    },
    fetchDeviceTickets() {
      Api()
        .get("/ticket/byDevice/" + this.$route.params.deviceId)
        .then(response => {
          this.deviceTickets = response.data;
          this.loadingKey += 1
        });
    },
    fetchDeviceComments() {
      Api()
        .get("/deviceComments/findByDevice/" + this.$route.params.deviceId)
        .then(response => {
          this.deviceComments = response.data.sort((a,b) => (a.createdAt < b.createdAt) ? 1 : ((b.createdAt < a.createdAt) ? -1 : 0)); ;
          this.loadingKey += 1
        });
    },
    goToLocations(item) {
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({
        path: "/locationnetworks/" + this.editedItem.id + "/locations"
      });
    },
    editItem(item) {
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.locationNetworks.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.locationNetworks.splice(index, 1);
      Api().delete("/locationnetworks/" + this.editedItem.id);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.locationNetworkInfo.tvOverFibre === false) {
        this.locationNetworkInfo.gtuIncluded = false;
      }
      if (this.locationNetworkInfo.lineRentalIncluded === false) {
        this.locationNetworkInfo.residentialLineRentalValue = 0;
      }
      Api().put("/locationnetworks/" + this.locationNetworkInfo.id, {
        name: this.locationNetworkInfo.name,
        locationNodeId: this.locationNetworkInfo.locationNodeId,
        lineRentalIncluded: this.locationNetworkInfo.lineRentalIncluded,
        tvOverFibre: this.locationNetworkInfo.tvOverFibre,
        gtuIncluded: this.locationNetworkInfo.gtuIncluded,
        activationFee: this.locationNetworkInfo.activationFee,
        routerInstallationFee: this.locationNetworkInfo.routerInstallationFee,
        residentialLineRentalValue: this.locationNetworkInfo
          .residentialLineRentalValue,
        isDeleted: false,
        isActive: this.locationNetworkInfo.isActive
      });

      this.locationNetworks.push(this.editedItem);
    }
  }
};
</script>
<style>
.v-chip.Active {
  background: #1ebb2c;
}
.v-chip.Inactive {
  background: #f0121e;
}
.v-chip.activationFee {
  background: #0fc5f3;
}
.v-chip.tvOverFibre {
  background: #b8c417;
}
.v-chip.gtuIncluded {
  background: #dfc013;
}
</style>

